import { render } from "./FaqDetailsItemChart.pug?vue&type=template&id=c68ed112&lang=pug"
import script from "./FaqDetailsItemChart.js?vue&type=script&lang=js"
export * from "./FaqDetailsItemChart.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__